<div class="app-spinner-container" *ngIf="loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
